























































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import ShopApi from '@/api/shopInfo/index'
import appconst from '@/lib/appconst'

@Component
export default class ShopWxaCodeQuery extends Vue {
  loading = false
  data = []
  qrCodeUrl = `${appconst.remoteServiceBaseUrl}/api/WeChatManagement/Weixin/qrcode/`
  filters = [
    {
      label: '',
      type: 'input',
      props: {
        placeholder: '请输入店铺编码'
      },
      key: 'KeyWord'
    }
  ]
  onSearch(value) {
    this.loadData({ KeyWord: value })
  }
  loadData(form = {}) {
    let keyWord = form['KeyWord']
    this.loading = true
    ShopApi.getList(1, 1, keyWord).then(res => {
      this.data = res.data.items
      this.loading = false
    })
  }
}
